/** @format */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { EventItem } from 'src/components/events/EventItem';

export function EventsWidget({ data }) {
  const { t } = useTranslation();
  const { events } = data;
  return (
    <div className="events-widget" data-width={data.w} data-height={data.h}>
      <div className="events-widget--title">
        <h2>{data.title}</h2>
      </div>
      {events && (
        <div className="events-widget--list-wrapper">
          <div className="events-widget--list">
            {events.length > 0 ? (
              events.map((item, index) => (
                <EventItem
                  item={item}
                  key={item.id || item.nid || item.link || `${item.title || 'event'}-${item.date || index}`}
                />
              ))
            ) : (
              <p className="events-widget--list-empty">{t('widget.noEvents')}</p>
            )}
          </div>
        </div>
      )}
      <div className="events-widget--link">
        <Link to="/events">{t('widget.allEvents')}</Link>
      </div>
    </div>
  );
}
